import { ExportOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const VisitLinkButton = () => {
  const { url, toggleToolbarVisible } = useLinkCardStore(state =>
    pick(state, ['url', 'toggleToolbarVisible'])
  )

  const handleVisitUrl = () => {
    toggleToolbarVisible()
    window.open(url, '_blank')
  }

  return (
    <MenuButton tooltip='访问链接' onClick={handleVisitUrl}>
      <ExportOutlined />
    </MenuButton>
  )
}
